import React from "react";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Popconfirm } from "antd";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEqual } from "lodash";
import SearchSelect from "../../../common/SearchSelect";
import {
    clearJobs, clearSingleJob,
    fetchJobById,
    fetchJobs
} from "../../../../api/menu/master-files/job-maintenance/actions";
import { findItemValueByIdFromArray } from "../../../../functions/find-item-by-id-from-array";
import { clearStores, fetchStores } from "../../../../api/menu/master-files/stores/actions";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";
import CustomCheckbox from "../../../custom/forms/custom-checkbox";
import {
    clearStoreTraits, deleteStoreTrait,
    fetchStoreTraitsList, fetchTraitsList, insertStoreTrait
} from "../../../../api/menu/master-files/traits/actions";
import sortObject from "../../../../functions/sort-object";

class StoreTraitsList extends React.Component {
    constructor(props) {
        super(props);

        const { jobId } = this.props;

        this.state = {
            jobId,
            jobOptions: [],
            jobTraitOptions: [],
            selectedJobTrait: null,
            selectedStores: [],
            selectedRow: null,
            isMultipleAdd: false
        };
        this.props.fetchJobs(false);

        this.handleCheckStores = this.handleCheckStores.bind(this);
        this.handleChangeJob = this.handleChangeJob.bind(this);
        this.handleStoreRowClick = this.handleStoreRowClick.bind(this);
        this.createStoreTrait = this.createStoreTrait.bind(this);
        this.handleChangeMultipleAdd = this.handleChangeMultipleAdd.bind(this);
        this.handleChangeTrait = this.handleChangeTrait.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { jobs, singleJob, jobTraits } = this.props;
        if (!isEqual(nextProps.jobs, jobs) && Array.isArray(nextProps.jobs)) {
            const sortedJobs = [];
                sortObject(nextProps.jobs, Object.keys(nextProps.jobs).map((value) =>
                    parseInt(value, 10)), "jobNumber", true)
                    .forEach(index => {
                        sortedJobs.push({
                            label: `${nextProps.jobs[index].jobNumber} - ${nextProps.jobs[index].description}`,
                            value: nextProps.jobs[index].id,
                        });
                    });

            this.setState({
                jobOptions: sortedJobs
            });
        }

        if (!isEqual(nextProps.jobTraits, jobTraits)) {
            this.setState({
                jobTraitOptions: nextProps.jobTraits.map(item => ({
                    value: item.id,
                    label: item.traitDescription
                }))
            });
        }

        if (!isEqual(nextProps.singleJob, singleJob) && nextProps.singleJob) {
            if (nextProps.singleJob.retailerId) {
                this.props.fetchTraitJobs(nextProps.singleJob.id);
                return this.props.fetchStores([nextProps.singleJob.retailerId]);
            }
            this.props.clearStores();
        }
    }

    componentWillUnmount() {
        this.props.clearJobs();
        this.props.clearStores();
        this.props.clearStoreTraits();
        this.props.clearSingleJob();
    }

    createStoreTrait = () => {
        const { jobId, selectedJobTrait, selectedStores, selectedRow, isMultipleAdd } = this.state;
        const callback = () => {
            this.setState({
               selectedStores: []
            }, () => this.props.fetchStoreTraitsList(selectedJobTrait, jobId));
        };
        const data = {
            jobId,
            traitId: selectedJobTrait,
            storeIds: isMultipleAdd ? selectedStores : [selectedRow]
        };

        this.props.insertStoreTrait(data, callback);
    };

    handleChangeJob = (option) => {
        const jobId = option.value;
        this.setState({
            jobId
        }, () => {
            this.props.clearStores();
            this.props.fetchJobById(jobId);
            this.props.clearStoreTraits();
        });
    };

    handleChangeTrait = (option) => {
        const traitId = option.value;
        this.setState({
            selectedJobTrait: traitId
        });
    };

    handleCheckStores = (id) => {
        const selectedStores = Object.assign([], this.state.selectedStores);
        if (selectedStores.includes(id)) {
            const index = selectedStores.findIndex(item => item === id);
            selectedStores.splice(index, 1);
        } else {
            selectedStores.push(id);
        }

        this.setState({
            selectedStores
        });
    };

    handleChangeMultipleAdd = (ev) => {
        this.setState({
            isMultipleAdd: ev.target.checked,
            selectedStores: []
        });
    }

    handleChangeAllSelect = (ev) => {
        const { checked } = ev.target;
        const { stores } = this.props;

        const selectedStores = checked ? stores.map(item => item.id) : [];

        this.setState({
            selectedStores
        });
    };

    handleStoreRowClick = (id) => {
        const { jobId } = this.state;

        this.setState({
            selectedRow: id,
            selectedJobTrait: null
        }, () => {
            this.props.fetchStoreTraitsList(id, jobId);
        });
    };

    getStoreColumns = () => {
        const { selectedStores, isMultipleAdd } = this.state;
        const { stores } = this.props;
        const columns = [];

        const isAllChecked =
            Array.isArray(selectedStores) && selectedStores.length ?
                stores.length === selectedStores.length : false;

        if (isMultipleAdd) {
            columns.push({
                Cell: ({ original }) => (
                    <CustomCheckbox
                        key={original.id}
                        className="checkbox"
                        name="checkbox"
                        checked={selectedStores.includes(original.id)}
                        onChange={() => this.handleCheckStores(original.id)}
                    />
                ),
                Header: () => (
                    <input
                        type="checkbox"
                        className="checkbox"
                        checked={isAllChecked}
                        onChange={this.handleChangeAllSelect}
                    />
                ),
                headerClassName: "text-left",
                sortable: false,
                filterable: false,
                resizable: false,
                minResizeWidth: 40,
                width: 40,
                className: "d-flex"
            });
        }
        columns.push({
            Header: "Store Number",
            headerClassName: "text-left",
            accessor: "storeNumber"
        });
        columns.push({
            Header: "Store Name",
            headerClassName: "text-left",
            accessor: "name"
        });

        return columns;
    };

    getTraitsColumns = () => {
        const { jobId, selectedRow } = this.state;
        const deleteCallback = () => this.props.fetchStoreTraitsList(selectedRow, jobId);

        const columns = [];
        const classNameFlexCenter = "d-flex justify-content-center align-items-center";

        columns.push({
            Header: "Trait Description",
            headerClassName: "text-left",
            accessor: "traitDescription"
        });
        columns.push({
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Popconfirm
                            title={`Delete "${original.traitDescription}"?`}
                            onConfirm={() =>
                                this.props.deleteStoreTrait(original.id, deleteCallback)}
                            placement="bottomRight"
                            okText="Yes"
                            cancelText="Cancel"
                        >
                            <Button variant="danger" size="sm">
                                <FontAwesomeIcon icon="times" />
                            </Button>
                        </Popconfirm>
                    </ButtonGroup>
                ),
                filterable: false,
                width: 100
            });

        return columns;
    };

    render() {
        const {
            jobOptions,
            jobId,
            selectedStores,
            jobTraitOptions,
            selectedJobTrait,
            isMultipleAdd,
            selectedRow
        } = this.state;

        const {
            loading,
            singleJob,
            jobLoading,
            stores,
            storeLoading,
            storeTraits,
            traitsLoading,
        } = this.props;

        const enableInsertTrait = selectedJobTrait &&
            (isMultipleAdd ? selectedStores.length > 0 : selectedRow !== null);

        const jobCurrent = findItemValueByIdFromArray(
            jobOptions,
            "value",
            jobId
        ) || null;

        const traitCurrent = findItemValueByIdFromArray(
            jobTraitOptions,
            "value",
            selectedJobTrait
        ) || null;

        return (
            <div>
                <div>
                    <h3>Store Traits Maintenance</h3>
                </div>

                <div className="form-group row">
                    <div className="col-3">
                        <label>Job</label>
                        <SearchSelect
                            className="custom-react-select"
                            isClearable={false}
                            isLoading={jobLoading}
                            options={jobOptions}
                            onChange={this.handleChangeJob}
                            value={jobCurrent}
                        />
                    </div>
                    <div className="col-3">
                        <label>Retailer</label>
                        <input
                            type="text"
                            className="form-control"
                            readOnly={true}
                            defaultValue={(singleJob && !loading) ? singleJob.retailer : ""}
                        />
                    </div>
                    <div className="col-3">
                        <label>Supplier</label>
                        <input
                            type="text"
                            className="form-control"
                            readOnly={true}
                            defaultValue={(singleJob && !loading) ? singleJob.supplier : ""}
                        />
                    </div>
                    <div className="col-3">
                        <div className="custom-control custom-checkbox mt-4">
                            <input
                                id="multipleStoresAdd"
                                type="checkbox"
                                checked={isMultipleAdd}
                                className="custom-control-input"
                                onChange={this.handleChangeMultipleAdd}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="multipleStoresAdd"
                            >
                                Add To Multiple Stores
                            </label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <ReactTable
                            data={stores}
                            loading={storeLoading}
                            columns={this.getStoreColumns()}
                            headerClassName="table-header"
                            showPagination={false}
                            pageSize={Math.max(stores.length, 20)}
                            resizable
                            className="-striped -highlight"
                            filterable={false}
                            defaultFilterMethod={filterCaseInsensitive}
                            getTrProps={(state, rowInfo) => {
                                if (rowInfo && rowInfo.original) {
                                    return {
                                        onClick: (e) => {
                                            if (e.target.name === "checkbox") {
                                                return;
                                            }
                                            this.handleStoreRowClick(rowInfo.original.id);
                                        },
                                        style: {
                                            background: rowInfo.original.id === this.state.selectedRow ? "#00AFEC" : "white",
                                            color: rowInfo.original.id === this.state.selectedRow ? "white" : "black",
                                            cursor: "pointer"
                                        }
                                    };
                                }
                                return {};
                            }}
                            getNoDataProps={() => ({
                                style: {
                                    zIndex: 0
                                }
                            })}
                            style={{
                                height: "calc(100vh - 185px)",
                            }}
                        />
                    </div>
                    <div className="col-6">
                        <div className="form-group row">
                            <div className="col-10">
                                <label>Trait</label>
                                <SearchSelect
                                    className="custom-react-select"
                                    isClearable={false}
                                    isLoading={false}
                                    options={jobTraitOptions}
                                    onChange={this.handleChangeTrait}
                                    value={traitCurrent}
                                />
                            </div>
                            <div className="col-2 mt-1">
                                <button
                                    className="btn btn-block btn-success mt-4"
                                    onClick={this.createStoreTrait}
                                    disabled={!enableInsertTrait}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <ReactTable
                            data={storeTraits}
                            loading={traitsLoading}
                            columns={this.getTraitsColumns()}
                            headerClassName="table-header"
                            showPagination={false}
                            pageSize={Math.max(storeTraits.length, 20)}
                            resizable
                            className="-striped -highlight"
                            filterable={false}
                            defaultFilterMethod={filterCaseInsensitive}
                            getNoDataProps={() => ({
                                style: {
                                    zIndex: 0
                                }
                            })}
                            style={{
                                height: "calc(100vh - 252px)",
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    jobs: state.jobs.jobs,
    jobLoading: state.jobs.loading,
    jobTraits: state.traits.jobTraits,
    singleJob: state.jobs.singleJob,
    stores: state.stores.stores,
    storeLoading: state.stores.loading,
    storeTraits: state.traits.storeTraits,
    traitsLoading: state.traits.loading
});

const mapStateToDispatch = dispatch => ({
    fetchJobs: bindActionCreators(fetchJobs, dispatch),
    fetchJobById: bindActionCreators(fetchJobById, dispatch),
    fetchTraitJobs: bindActionCreators(fetchTraitsList, dispatch),
    fetchStores: bindActionCreators(fetchStores, dispatch),
    clearStores: bindActionCreators(clearStores, dispatch),
    clearJobs: bindActionCreators(clearJobs, dispatch),
    clearSingleJob: bindActionCreators(clearSingleJob, dispatch),
    fetchStoreTraitsList: bindActionCreators(fetchStoreTraitsList, dispatch),
    insertStoreTrait: bindActionCreators(insertStoreTrait, dispatch),
    deleteStoreTrait: bindActionCreators(deleteStoreTrait, dispatch),
    clearStoreTraits: bindActionCreators(clearStoreTraits, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(StoreTraitsList);
